import createReducer from '../../utils/createReducer';
import {
  CREATE_CUSTODIAN_ERROR,
  CREATE_CUSTODIAN_SUCCESS,
  GET_CUSTODIANS_ERROR,
  GET_CUSTODIANS_SUCCESS,
  UPDATE_CUSTODIAN_ERROR,
  UPDATE_CUSTODIAN_SUCCESS,
} from '../../actions/custodians/custodiansActionConstants';

const initialState = {
  Custodians: [],
  Custodian: {},
  error: '',
};

export default createReducer(
  {
    [GET_CUSTODIANS_SUCCESS]: fetchCustodians,
    [GET_CUSTODIANS_ERROR]: fetchCustodiansError,
    [CREATE_CUSTODIAN_SUCCESS]: createCustodian,
    [CREATE_CUSTODIAN_ERROR]: createCustodianError,
    [UPDATE_CUSTODIAN_SUCCESS]: updateCustodian,
    [UPDATE_CUSTODIAN_ERROR]: updateCustodianError,
  },
  initialState,
);

function fetchCustodians(state, { payload }) {
  return {
    ...state,
    Custodians: payload,
    error: '',
  };
}

function fetchCustodiansError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function createCustodian(state, { payload }) {
  return {
    ...state,
    Custodian: payload,
    error: '',
  };
}

function createCustodianError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function updateCustodian(state, { payload }) {
  return {
    ...state,
    Custodian: payload,
    error: '',
  };
}

function updateCustodianError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}
